if (!customElements.get('infinite-scroll')) {
  customElements.define(
    'infinite-scroll',
    class InfiniteScroll extends HTMLElement {
      constructor() {
        super();
        this.pages = Number(this.getAttribute('data-pages'));
        this.page = Number(this.getAttribute('data-current-page'));
        this.containerSelector = this.getAttribute('data-container');
        this.button = this.querySelector('.load-more-button');
        this.loadMoreText = this.getAttribute('data-load-more-text');
        this.loadingText = this.getAttribute('data-loading-text');
      }

      connectedCallback() {
        if (this.button) {
          this.button.addEventListener('click', () => this.loadMoreProducts());
        }
        this.updateButtonVisibility();
      }

      updateButtonVisibility() {
        if (!this.button) return;
        this.button.style.display = this.page < this.pages ? 'block' : 'none';
      }

      async loadMoreProducts() {
        if (this.page < this.pages) {
          this.page += 1;
          this.setAttribute('loading', '');
          this.button.disabled = true;
          this.button.textContent = this.loadingText;

          const url = `${window.location.pathname}${window.location.search ? window.location.search + '&' : '?'}page=${this.page}`;
          try {
            const response = await fetch(url);
            const text = await response.text();
            const newPageHTML = new DOMParser().parseFromString(text, 'text/html');
            const newItems = newPageHTML.querySelector(this.containerSelector);
            const currentContainer = document.querySelector(this.containerSelector);

            if (newItems && newItems.children.length > 0 && currentContainer) {
              const appendedItems = Array.from(newItems.children).map((item) => item.cloneNode(true));
              currentContainer.append(...appendedItems);
              this.resetMasonry(appendedItems);
            }

            this.button.disabled = false;
            this.button.textContent = this.loadMoreText;
          } catch (error) {
            console.error('Error loading more products:', error);
            this.button.disabled = false;
            this.button.textContent = this.loadMoreText;
          } finally {
            this.removeAttribute('loading');
            this.updateButtonVisibility(); // Check for more products
          }
        }
      }

      resetMasonry(items) {
        const masonry = document.querySelector('[data-masonry]');
        if (!masonry) return;
        const msnry = new Masonry('[data-masonry]', {});
        if (Array.isArray(items) && items.length) msnry.appended(items);
        msnry.layout();
      }
    },
  );
}
